<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <view-wfh-responsibility>
        </view-wfh-responsibility> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import viewWfhResponsibility from './todo-view-wfh-responsibility'
export default {
    components: {
        viewWfhResponsibility
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-responsibility-form/base-view-wfh-responsibility.vue